export const declarations = {
	fileLanguages: ["pl", "en", "de", "es", "it"],
};
